import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronRight, FiSearch, FiDollarSign, FiZap, FiWind, FiShield, FiVolume2, FiCloud, FiHome } = FiIcons;

const topics = [
  {
    title: "Mieten oder Kaufen in Deutschland heute: Was Daten und Trends wirklich nahelegen",
    link: "/blog/mieten-oder-kaufen",
    icon: FiHome,
    category: "Finanzen & Markt"
  },
  {
    title: "Schafwolle Dämmung – Vorteile & Nachteile im Detail",
    link: "/blog/schafwolle-daemmung-vorteile-nachteile", // URL UPDATE
    icon: FiCloud,
    category: "Ökologische Baustoffe"
  },
  {
    title: "Schallschutz bei Holzbalkendecken: Warum Mineralwolle allein ein Fehler ist",
    link: "/blog/schallschutz-holzbalkendecke",
    icon: FiVolume2,
    category: "Bauphysik & Akustik"
  },
  {
    title: "Kauft das bitte nicht – bevor ihr DAS getan habt!",
    link: "/blog/ankaufspruefung-mehrfamilienhaus",
    icon: FiSearch,
    category: "Ankaufsprüfung"
  },
  {
    title: "Günstiger bauen statt über 3.000 €/m²",
    link: "/blog/wirtschaftliches-bauen",
    icon: FiDollarSign,
    category: "Wirtschaftlichkeit"
  },
  {
    title: "Fensterverglasung 2026: Was lohnt sich?",
    link: "/blog/fensterverglasung-2026",
    icon: FiZap,
    category: "Energieeffizienz"
  },
  {
    title: "Dampfbremse in der Holzdecke?",
    link: "/blog/dampfbremse-holzdecke",
    icon: FiWind,
    category: "Bauphysik"
  }
];

function RelatedTopics() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Filter out the current post
  const relatedPosts = topics.filter(topic => topic.link !== currentPath).slice(0, 3);

  return (
    <section className="py-16 bg-gray-50 border-t border-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
          <span className="w-8 h-1 bg-mk-red-700 mr-4 rounded-full"></span>
          Dieser Beitrag könnte Sie auch interessieren
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {relatedPosts.map((post, index) => (
            <motion.div
              key={post.link}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Link to={post.link} className="group block h-full bg-white p-6 rounded-xl shadow-sm hover:shadow-md border border-gray-100 transition-all duration-300">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-[10px] font-bold text-mk-teal-600 uppercase tracking-widest bg-mk-teal-50 px-2 py-1 rounded">
                    {post.category}
                  </span>
                  <SafeIcon icon={post.icon} className="text-gray-300 group-hover:text-mk-teal-500 transition-colors" />
                </div>
                <h4 className="text-sm font-bold text-gray-900 mb-4 group-hover:text-mk-teal-600 transition-colors leading-snug">
                  {post.title}
                </h4>
                <div className="flex items-center text-mk-red-700 text-xs font-bold">
                  <span>Weiterlesen</span>
                  <SafeIcon icon={FiChevronRight} className="ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedTopics;